<template>
  <div class="wdqb-box" v-if="data">
    <div class="wdqb-content">
      <!-- 左侧：钱包信息 -->
      <div class="wdqb-left">
        <!-- 币种卡片 -->
        <div class="wdqb-coin-card">
		  <img :src="data.currencyLogo" alt="" class="wdqb-coin-icon"/>
          <div class="wdqb-coin-info">
            <span class="wdqb-coin-name">{{data.currencyName}}</span>
            <span class="wdqb-coin-desc">{{$t('all.lianshangbaobishibei')}}</span>
          </div>
        </div>
        <!-- 余额信息 -->
        <div class="wdqb-item">
          <span class="wdqb-item-label">{{$t('all.zonge')}}</span>
          <span class="wdqb-item-value">{{data.sumAmount}} {{data.currencyName}}</span>
        </div>
        <div class="wdqb-item">
          <span class="wdqb-item-label">{{$t('all.keyongshuliang')}}</span>
          <span class="wdqb-item-value">{{data.sumAvailableAmount}} {{data.currencyName}}</span>
        </div>
        <div class="wdqb-item">
          <span class="wdqb-item-label">{{$t('all.dongjieshuliang')}}</span>
          <span class="wdqb-item-value">{{data.sumFreezeAmount}} {{data.currencyName}}</span>
        </div>
        <!-- 操作按钮 -->
        <div class="wdqb-actions">
          <div :class="activeTab === 'deposit' ? 'wdqb-action-btn wdqb-action-gradient' : 'wdqb-action-btn'" @click="handleSwitchDeposit">{{$t('all.chongbi')}}</div>
          <div :class="activeTab === 'withdraw' ? 'wdqb-action-btn wdqb-action-gradient' : 'wdqb-action-btn'" @click="handleSwitchWithdraw">{{$t('all.tibi')}}</div>
        </div>
        <!-- 查看流水 -->
        <div class="wdqb-flow-btn" @click="handleGoFlow">{{$t('all.chakanliushui')}}</div>
      </div>
      <!-- 右侧面板 -->
      <div class="wdqb-right" v-if="activeTab">
        <div class="wd-right-scroll">
        <!-- 充币面板 -->
        <template v-if="activeTab === 'deposit'">
          <!-- 币种选择 -->
          <div class="wdqb-right-item" @click="showCurrencyPicker = true">
            <span class="wdqb-right-label">{{$t('all.xuanzebizhong')}}</span>
            <div class="wdqb-right-item-right">
              <span class="wdqb-right-value">{{currentCurrencyName}}</span>
              <img class="wdqb-right-arrow" src="../../../assets/image/quqianbao@2x.png" alt="" />
            </div>
          </div>
          <!-- 网络 -->
          <div class="wdqb-right-item">
            <span class="wdqb-right-label">{{$t('all.wangluo')}}</span>
            <span class="wdqb-right-value wdqb-text-green" v-if="data.rechargeNetworkConfigList && data.rechargeNetworkConfigList[0]">{{data.rechargeNetworkConfigList[0].symbol}}</span>
          </div>
          <div class="wdqb-right-tip">{{$t('all.chongzhitip')}}</div>
          <!-- 储值地址 -->
          <div class="wdqb-right-item">
            <span class="wdqb-right-label">{{$t('all.chongbidizhi')}}</span>
            <div class="wdqb-right-item-right">
              <span class="wdqb-right-value wdqb-text-green" :title="rechargeData.address">{{rechargeData.address}}</span>
              <img src="../../../assets/image/fuzhi_18@2x.png" alt="" class="wdqb-right-copy-img" @click="handleCopyAddress"/>
            </div>
          </div>
          <!-- 二维码 -->
          <div class="wdqb-qr" v-if="rechargeData.address">
            <canvas ref="qrcodeCanvas" class="wdqb-qr-canvas"></canvas>
          </div>
          <!-- 充值说明协议 -->
          <div class="wdqb-right-agreement" v-if="agreementContent" v-html="agreementContent"></div>
        </template>
        <!-- 提币面板 -->
        <template v-if="activeTab === 'withdraw'">
          <div class="wdqb-right-item">
            <span class="wdqb-right-label">{{$t('all.tibidizhi')}}</span>
            <input class="wdqb-right-input" v-model="withdrawAddress" :placeholder="$t('all.qingshurutibidizhi')" />
          </div>
          <div class="wdqb-right-item">
            <span class="wdqb-right-label">{{$t('all.wangluo')}}</span>
            <span class="wdqb-right-value">{{data.withdrawalNetworkConfigList && data.withdrawalNetworkConfigList[0] ? data.withdrawalNetworkConfigList[0].symbol : ''}}</span>
          </div>
          <div class="wdqb-right-item">
            <span class="wdqb-right-label">{{$t('all.tibishuliang')}}</span>
            <input class="wdqb-right-input" v-model="withdrawAmount" :placeholder="$t('all.qingshuru')" />
          </div>
          <div class="wdqb-right-min-tip" v-if="data.withdrawalNetworkConfigList && data.withdrawalNetworkConfigList[0] && data.withdrawalNetworkConfigList[0].minWithdrawalAmount">{{$t('all.zuiditixianjin')}}{{data.withdrawalNetworkConfigList[0].minWithdrawalAmount}} {{data.currencyName}}</div>
          <div class="wdqb-right-error" v-if="withdrawError">{{withdrawError}}</div>
          <div class="wdqb-right-estimate">
            <div class="wdqb-right-estimate-header">
              <span class="wdqb-right-estimate-title">{{$t('all.tibishisuan')}}</span>
              <span class="wdqb-right-estimate-tag">{{$t('all.shouxufeibilv')}}{{data.withdrawalNetworkConfigList && data.withdrawalNetworkConfigList[0] ? data.withdrawalNetworkConfigList[0].withdrawalServiceChargeRatio : 0}}</span>
            </div>
            <div class="wdqb-right-estimate-row">
              <span>{{$t('all.shouxufei')}}</span>
              <span>{{withdrawFee}} {{data.currencyName}}</span>
            </div>
            <div class="wdqb-right-estimate-row">
              <span>{{$t('all.shijidaozhang')}}</span>
              <span class="wdqb-text-green">{{withdrawActual}} {{data.currencyName}}</span>
            </div>
          </div>
          <div class="wdqb-right-btn" @click="handleWithdraw">{{$t('all.tijiaotibi')}}</div>
        </template>
        </div>
        <!-- 固定在底部的最小充值金额提示 -->
        <div class="wdqb-right-min-tip wdqb-right-min-tip--fixed" v-if="activeTab === 'deposit' && data.rechargeNetworkConfigList && data.rechargeNetworkConfigList[0]">{{$t('all.zuidicharge')}}{{data.rechargeNetworkConfigList[0].minRechargeAmount}} {{data.currencyName}}，{{$t('all.xiaoyuzuixiaoe')}}</div>
      </div>
    </div>

    <!-- 选择提币地址弹框 -->
    <div class="wdqb-overlay" v-if="showAddressModal" @click="showAddressModal = false"></div>
    <div class="wdqb-address-modal" v-if="showAddressModal" @click.stop>
      <div class="wdqb-address-title">{{$t('all.xuanzetibidizhi')}}</div>
      <div class="wdqb-address-search">
		<img class="wdqb-address-search-icon" src="../../../assets/image/sousuo_18@2x.png" alt=""/>
        <input class="wdqb-address-search-input" v-model="searchAddress" :placeholder="$t('all.sousuodizhi')" />
      </div>
      <div class="wdqb-address-list">
        <div class="wdqb-address-item" v-for="(item, index) in addressList" :key="index">
          <div class="wdqb-address-item-info">
            <span class="wdqb-address-item-label">{{item.label}}</span>
            <span class="wdqb-address-item-value">{{item.address}}</span>
          </div>
          <div class="wdqb-address-item-btn" @click="handleSelectAddress(item)">{{$t('all.xuanze')}}</div>
        </div>
      </div>
    </div>

    <!-- 币种选择弹框 -->
    <div class="wdqb-overlay" v-if="showCurrencyPicker" @click="showCurrencyPicker = false"></div>
    <div class="wdqb-currency-modal" v-if="showCurrencyPicker" @click.stop>
      <div class="wdqb-currency-title">{{$t('all.xuanzebizhong')}}</div>
      <div class="wdqb-currency-list">
        <div class="wdqb-currency-item" v-for="(item, index) in currencyList" :key="item.currencyId"
          :class="{'wdqb-currency-item--active': String(item.currencyId) === String(currencyId)}"
          @click="onCurrencyConfirm(item)">
          <img :src="item.currencyLogo" class="wdqb-currency-item-icon" alt="" />
          <span class="wdqb-currency-item-name">{{item.unitText || item.currencyName}}</span>
          <span class="wdqb-currency-item-check" v-if="String(item.currencyId) === String(currencyId)">✓</span>
        </div>
      </div>
    </div>

    <!-- 安全验证弹框 -->
    <div class="wdqb-overlay" v-if="showVerifyModal" @click="closeVerify"></div>
    <div class="wdqb-verify-modal" v-if="showVerifyModal" @click.stop>
      <div class="wdqb-verify-header">
        <span class="wdqb-verify-title">{{$t('all.anquanyanzheng')}}</span>
        <img class="wdqb-verify-close" src="../../../assets/image/tanchuang_x_b@2x.png" alt="" @click="closeVerify" />
      </div>
      <div class="wdqb-verify-section">
        <span class="wdqb-verify-label">{{$t('all.youxiang')}}</span>
        <div class="wdqb-verify-box">
          <span class="wdqb-verify-email">{{userEmail}}</span>
        </div>
      </div>
      <div class="wdqb-verify-section">
        <span class="wdqb-verify-label">{{$t('all.yanzhengma')}}</span>
        <div class="wdqb-verify-box wdqb-verify-code-row">
          <input class="wdqb-verify-input" type="text" v-model="emailCode" :placeholder="$t('all.qingshuruyouxiangyanzhengma')" />
          <span class="wdqb-verify-send" :class="{'wdqb-verify-send--disabled': codeCountdown > 0}" @click="sendEmailCode">
            {{codeCountdown > 0 ? codeCountdown + 's' : $t('all.fasongyanzhengma')}}
          </span>
        </div>
      </div>
      <div class="wdqb-verify-confirm" @click="confirmVerifyAndWithdraw">{{$t('all.queren')}}</div>
    </div>

    <!-- 提币申请成功弹框 -->
    <div class="wdqb-overlay" v-if="showWithdrawSuccess" @click="showWithdrawSuccess = false"></div>
    <div class="wdqb-success-modal" v-if="showWithdrawSuccess" @click.stop>
      <div class="wdqb-success-icon">
        <svg viewBox="0 0 24 24" width="48" height="48">
          <path d="M9 16.2L4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4L9 16.2z" fill="#FFFFFF"/>
        </svg>
      </div>
      <div class="wdqb-success-title">{{$t('all.tibishenqingyitijiao') || '提币申请已提交'}}</div>
      <div class="wdqb-success-desc">{{$t('all.tibishenqingdesc') || '后台审核通过后，将进行链上提币。'}}</div>
      <div class="wdqb-success-row">
        <span class="wdqb-success-row-label">{{$t('all.zhuangtai') || '状态'}}</span>
        <span class="wdqb-success-row-value">{{withdrawSuccessStatus || ($t('all.shenhezhong') || '审核中')}}</span>
      </div>
      <div class="wdqb-success-row">
        <span class="wdqb-success-row-label">{{$t('all.shijidaozhang') || '实际到账'}}</span>
        <span class="wdqb-success-row-value">{{withdrawSuccessActual}} {{data.currencyName}}</span>
      </div>
      <div class="wdqb-success-btn" @click="handleGoFlow">{{$t('all.chakantibi') || '查看提币记录'}}</div>
    </div>
  </div>
</template>

<script>
import { getUserWalletInfo, getUserWalletList, toRecharge, toWithdrawal } from "@/api/qianbao";
import { getHtmlContentByType, getPresentUserInfo } from "@/api/user";
import { sendSmsCode } from "@/api/login";
import QRCode from 'qrcode';
export default {
  data() {
    return {
      currencyId: '',
	  data: '',
      activeTab: '',
      showAddressModal: false,
      searchAddress: '',
      addressList: [
        { label: '常用地址', address: '0x82...8F91' },
        { label: '交易所地址', address: '0x82...8F91' },
        { label: '冷钱包', address: '0x82...8F91' },
      ],
      // 充币相关
      rechargeData: { address: '' },
      agreementContent: '',
      currencyList: [],
      showCurrencyPicker: false,
      // 提币相关
      withdrawAmount: '',
      withdrawAddress: '',
      withdrawFee: '0.00',
      withdrawActual: '0.00',
      withdrawError: '',
      // 提币成功弹框
      showWithdrawSuccess: false,
      withdrawSuccessStatus: '',
      withdrawSuccessActual: '',
      // 安全验证弹框
      showVerifyModal: false,
      userEmail: '',
      emailCode: '',
      codeCountdown: 0,
      codeTimer: null
    };
  },
  computed: {
    currentCurrencyName() {
      if (this.data && this.data.currencyName) return this.data.currencyName
      const cur = this.currencyList.find(c => String(c.currencyId) === String(this.currencyId))
      return cur ? (cur.unitText || cur.currencyName || '') : ''
    }
  },
  mounted() {
  	this.currencyId = this.$route.query.currencyId || ''
  	this.getCurrencyList()
  	this.getUserWalletInfo()
  	this.getAgreement()
  	this.getUserEmail()
  },
  watch: {
    withdrawAmount(val) {
      // 限制输入小数位数（最多contractDecimals位）
      if (val && val.includes('.')) {
        const maxDecimals = parseInt(this.data && this.data.contractDecimals) || 18;
        const parts = val.split('.');
        if (parts[1] && parts[1].length > maxDecimals) {
          this.withdrawAmount = parts[0] + '.' + parts[1].slice(0, maxDecimals);
          return;
        }
      }
      this.calculateWithdraw(val);
    }
  },
  methods: {
	// 币种列表
	async getCurrencyList() {
	  try {
		const res = await getUserWalletList()
		this.currencyList = (res && res.data && res.data.walletList) || []
	  } catch (e) {
		console.error('获取币种列表失败:', e)
	  }
	},
	// 充值说明协议 type=3
	async getAgreement() {
	  try {
		const res = await getHtmlContentByType({ type: 3 })
		this.agreementContent = (res && res.data) || ''
	  } catch (e) {
		console.error('获取充值协议失败:', e)
	  }
	},
	// 切换币种
	onCurrencyConfirm(item) {
	  if (String(item.currencyId) === String(this.currencyId)) {
		this.showCurrencyPicker = false
		return
	  }
	  this.currencyId = item.currencyId
	  this.showCurrencyPicker = false
	  this.getUserWalletInfo()
	},
	// 生成二维码
	generateQrCode() {
	  this.$nextTick(() => {
		const canvas = this.$refs.qrcodeCanvas;
		if (!canvas || !this.rechargeData.address) return;
		QRCode.toCanvas(canvas, this.rechargeData.address, {
		  width: 160,
		  margin: 2,
		  color: { dark: '#000000', light: '#ffffff' }
		}, (error) => {
		  if (error) console.error('生成二维码失败:', error);
		});
	  });
	},
	async getUserWalletInfo(skipTabReset) {
	  const res = await getUserWalletInfo({currencyId:this.currencyId})
	  this.data = res.data
	  // 如果传了 skipTabReset，保持当前 tab 不变
	  if (skipTabReset) return
	  // 根据配置设置默认 tab
	  const hasRecharge = this.data.rechargeNetworkConfigList && this.data.rechargeNetworkConfigList.length > 0;
	  const hasWithdraw = this.data.withdrawalNetworkConfigList && this.data.withdrawalNetworkConfigList.length > 0;
	  if (hasRecharge) {
	    this.activeTab = 'deposit';
	    // 自动调用充值接口获取地址 + 生成二维码
	    const netConfig = this.data.rechargeNetworkConfigList[0];
	    if (netConfig.blockchainNetworkConfigId) {
	      this.fetchRechargeAddress(netConfig.blockchainNetworkConfigId)
	    }
	  } else if (hasWithdraw) {
	    this.activeTab = 'withdraw';
	  } else {
	    this.activeTab = '';
	  }
	},
	// 调用充值接口获取储值地址
	async fetchRechargeAddress(blockchainNetworkConfigId) {
	  try {
	    const res = await toRecharge({ blockchainNetworkConfigId })
	    const newData = (res && res.data) || {}
	    // 只有地址变化时才更新，避免切换币种时先清空再渲染造成闪动
	    if (newData.address && newData.address !== this.rechargeData.address) {
	      this.rechargeData = newData
	      this.generateQrCode()
	    } else if (newData.address) {
	      // 地址没变也更新其他字段
	      this.rechargeData = newData
	    }
	  } catch (e) {
	    console.error('调用充值接口失败:', e)
	  }
	},
    calculateWithdraw(val) {
      this.withdrawError = '';
      this.withdrawFee = '0.00';
      this.withdrawActual = '0.00';

      if (!val || parseFloat(val) <= 0) {
        return;
      }

      const amount = parseFloat(val);
      const minAmount = parseFloat(this.data.withdrawalNetworkConfigList[0].minWithdrawalAmount || 0);
      const maxAmount = parseFloat(this.data.withdrawalNetworkConfigList[0].maxWithdrawalAmount || -1);
      const availableAmount = parseFloat(this.data.sumAvailableAmount || 0);
      const feeRatio = parseFloat(this.data.withdrawalNetworkConfigList[0].withdrawalServiceChargeRatio || 0);
      const decimals = parseInt(this.data.contractDecimals) || 18;

      if (amount < minAmount) {
        this.withdrawError = this.$t('all.zuiditixianjin') + minAmount + ' ' + this.data.currencyName;
        return;
      }

      if (maxAmount !== -1 && amount > maxAmount) {
        this.withdrawError = this.$t('all.meiriyushutixian') + maxAmount + ' ' + this.data.currencyName;
        return;
      }

      if (amount > availableAmount) {
        this.withdrawError = this.$t('all.keyongyu') + availableAmount + ' ' + this.data.currencyName;
        return;
      }

      const fee = amount * feeRatio;
      const actual = amount - fee;

      this.withdrawFee = this.truncateDecimal(fee, decimals);
      this.withdrawActual = this.truncateDecimal(actual, decimals);
    },
    // 截取小数位（不四舍五入），并去掉末尾多余的零
    truncateDecimal(num, decimals) {
      const d = decimals !== undefined ? decimals : 18;
      if (d === 0) return Math.floor(num).toString();
      // 先用合理精度 round 掉浮点误差（最多保留 contractDecimals 位，但计算用 10 位精度去除浮点噪声）
      const safePrecision = Math.min(d, 10);
      const rounded = parseFloat(num.toFixed(safePrecision));
      // 再按 contractDecimals 截取（向下取整）
      const factor = Math.pow(10, safePrecision);
      const truncated = Math.floor(rounded * factor) / factor;
      // 转字符串并去掉末尾多余的零，最少保留2位
      let result = truncated.toFixed(safePrecision);
      const dotIndex = result.indexOf('.');
      if (dotIndex !== -1) {
        let end = result.length - 1;
        while (end > dotIndex + 2 && result[end] === '0') {
          end--;
        }
        result = result.slice(0, end + 1);
      }
      return result;
    },
    handleGoFlow() {
      this.$router.push({ path: '/liushuijilu',query: {
        currencyId: this.data.currencyId,
        unitText:this.data.currencyName
      }});
    },
    handleSwitchDeposit() {
      if (!this.data.rechargeNetworkConfigList || this.data.rechargeNetworkConfigList.length === 0) {
        this.$message.warning(this.$t('all.gaibizhongbuzhichichongzhi'));
        return;
      }
      this.activeTab = 'deposit';
      // 切换到充币tab时重新拉取地址
      const netConfig = this.data.rechargeNetworkConfigList[0];
      if (netConfig.blockchainNetworkConfigId) {
        this.fetchRechargeAddress(netConfig.blockchainNetworkConfigId)
      }
    },
    handleSwitchWithdraw() {
      if (!this.data.withdrawalNetworkConfigList || this.data.withdrawalNetworkConfigList.length === 0) {
        this.$message.warning(this.$t('all.gaibizhongbuzhichitibi'));
        return;
      }
      this.activeTab = 'withdraw';
    },
    handleCopyAddress() {
      if (!this.rechargeData.address) return;
      navigator.clipboard.writeText(this.rechargeData.address);
      this.$message.success(this.$t('all.fuzhichenggong'));
    },
    handleWithdraw() {
      if (!this.withdrawAddress) {
        this.$message.warning(this.$t('all.qingshurutibidizhi'));
        return;
      }
      if (!this.withdrawAmount || parseFloat(this.withdrawAmount) <= 0) {
        this.$message.warning(this.$t('all.qingshuru'));
        return;
      }
      if (this.withdrawError) {
        this.$message.warning(this.withdrawError);
        return;
      }
      // 校验通过：弹出安全验证弹框
      this.emailCode = ''
      this.showVerifyModal = true
      if (!this.userEmail) {
        this.getUserEmail()
      }
    },
    // 获取用户邮箱
    async getUserEmail() {
      try {
        const res = await getPresentUserInfo()
        this.userEmail = (res && res.data && res.data.email) || ''
      } catch (e) {
        console.error('获取用户信息失败:', e)
      }
    },
    // 邮箱掩码
    maskEmail(email) {
      if (!email) return ''
      const atIndex = email.indexOf('@')
      if (atIndex < 0) return email
      const name = email.substring(0, atIndex)
      const domain = email.substring(atIndex)
      if (name.length <= 2) return name.charAt(0) + '****' + domain
      return name.charAt(0) + '****' + name.charAt(name.length - 1) + domain
    },
    // 发送邮箱验证码
    async sendEmailCode() {
      if (this.codeCountdown > 0) return
      if (!this.userEmail) {
        this.$message.warning(this.$t('all.qingshuruningdeyouxiangzhanghao'))
        return
      }
      try {
        const res = await sendSmsCode({ email: this.userEmail, smsType: 3 })
        this.$message.success(res.msg || this.$t('all.fasongchenggong'))
        this.codeCountdown = 60
        this.startCodeCountdown()
      } catch (e) {
        console.error('发送验证码失败:', e)
      }
    },
    // 验证码倒计时
    startCodeCountdown() {
      this.clearCodeTimer()
      const tick = () => {
        this.codeCountdown--
        if (this.codeCountdown > 0) {
          this.codeTimer = setTimeout(tick, 1000)
        } else {
          this.clearCodeTimer()
        }
      }
      this.codeTimer = setTimeout(tick, 1000)
    },
    clearCodeTimer() {
      if (this.codeTimer) {
        clearTimeout(this.codeTimer)
        this.codeTimer = null
      }
    },
    closeVerify() {
      this.showVerifyModal = false
    },
    // 安全验证确认：携带验证码直接提币
    async confirmVerifyAndWithdraw() {
      if (!this.emailCode) {
        this.$message.warning(this.$t('all.qingshuruyanzhengma'))
        return
      }
      try {
        const res = await toWithdrawal({
          blockchainNetworkConfigId: this.data.withdrawalNetworkConfigList[0].blockchainNetworkConfigId,
          amount: this.withdrawAmount,
          address: this.withdrawAddress,
          smsCode: this.emailCode
        })
        // 提交成功：关闭验证弹框，显示成功弹框
        this.showVerifyModal = false
        this.withdrawSuccessStatus = (res && res.data && res.data.statusName) || (this.$t('all.shenhezhong') || '审核中')
        this.withdrawSuccessActual = this.withdrawActual
        this.showWithdrawSuccess = true
        this.withdrawAmount = ''
        this.withdrawAddress = ''
        this.emailCode = ''
        this.getUserWalletInfo(true)
      } catch (e) {
        console.error('提币失败:', e)
        if (e && e.msg) {
          this.$message.error(e.msg)
        }
      }
    },
    handleSelectAddress(item) {
      this.showAddressModal = false;
      this.$router.push('/querentbi');
    },
    formatAddress(address) {
      if (!address) return '';
      if (address.length <= 10) return address;
      return address.slice(0, 6) + '...' + address.slice(-4);
    }
  },
  beforeDestroy() {
    this.clearCodeTimer()
  }
};
</script>

<style scoped lang="scss">
@import "./wodequanbao.css";
</style>



// WEBPACK FOOTER //
// wodequanbao.vue?30527944